import type { NativeEmbedClientId } from '../types';

import { NATIVE_EMBED_BRIDGE_QUERY_PARAM_KEYS } from './query-param-keys';

export type NativeEmbedBridgeParams = {
	embedClientId: NativeEmbedClientId;
	hostClientId: NativeEmbedClientId;
};

export type NativeEmbedIframeDataAttributes = Record<string, string>;

export interface NativeEmbedIFrameSetup {
	clientId: NativeEmbedClientId;
	getIframeDataAttributes: () => NativeEmbedIframeDataAttributes;
	/** Returns the native embed bridge query params (nativeEmbedChildId, nativeEmbedParentId) to append to the iframe URL. */
	getQueryParams: () => Record<string, string>;
}

const ROVO_RECEIVER_ID_DATA_ATTR = 'data-rovo-receiver-id';
const [ROVO_CHILD_ID_QUERY_PARAM_KEY, ROVO_PARENT_ID_QUERY_PARAM_KEY] =
	NATIVE_EMBED_BRIDGE_QUERY_PARAM_KEYS;

export function createNativeEmbedClientIframeIntegrator(
	bridgeParams: NativeEmbedBridgeParams,
): NativeEmbedIFrameSetup {
	const { embedClientId, hostClientId } = bridgeParams;
	return {
		clientId: embedClientId,
		getQueryParams: () => ({
			[ROVO_CHILD_ID_QUERY_PARAM_KEY]: embedClientId,
			[ROVO_PARENT_ID_QUERY_PARAM_KEY]: hostClientId,
		}),
		getIframeDataAttributes: () => ({
			[ROVO_RECEIVER_ID_DATA_ATTR]: embedClientId,
		}),
	};
}

export type NativeEmbedBridgeClientQueryParams = {
	childClientId: NativeEmbedClientId;
	parentClientId: NativeEmbedClientId;
};

export function maybeParseNativeEmbedParams(
	params: URLSearchParams,
): NativeEmbedBridgeClientQueryParams | undefined {
	const id = params.get(ROVO_CHILD_ID_QUERY_PARAM_KEY) as NativeEmbedClientId | undefined;
	const parentId = params.get(ROVO_PARENT_ID_QUERY_PARAM_KEY) as NativeEmbedClientId | undefined;
	if (!id || id.length === 0 || !parentId || parentId.length === 0) {
		return undefined;
	}
	return { childClientId: id, parentClientId: parentId };
}
